var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editor-tooltip-view" },
    [
      _c(
        "IconComponent",
        {
          staticClass: "editor-tooltip-view-type-icon",
          class: {
            "editor-tooltip-view-type-icon-info": _vm.isInfo,
            "editor-tooltip-view-type-icon-warning": _vm.isWarning,
          },
        },
        [_vm._v(_vm._s(_vm.isInfo ? "alert_info" : "alert_warning"))]
      ),
      _c("div", { staticClass: "editor-tooltip-view-content" }, [
        _vm._v(_vm._s(_vm.content)),
      ]),
      _c(
        "IconComponent",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasCloseButton,
              expression: "hasCloseButton",
            },
          ],
          staticClass: "editor-tooltip-view-close-icon",
          on: { click: _vm.onCloseTooltipClick },
        },
        [_vm._v("close")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }